'use client';

import { useEffect } from 'react';
import type { Locale } from '@/lib/i18n';

interface BlogSlugMappingInjectorProps {
  slugMappings: Record<Locale, string>;
}

/**
 * Client component that injects blog slug mappings into window object
 * This allows the LanguageSwitcher to generate correct cross-locale links
 */
export default function BlogSlugMappingInjector({ slugMappings }: BlogSlugMappingInjectorProps) {
  useEffect(() => {
    // Inject slug mappings into window for the language switcher to use
    (window as unknown as { __BLOG_SLUG_MAPPINGS__?: Record<Locale, string> }).__BLOG_SLUG_MAPPINGS__ = slugMappings;

    // Cleanup on unmount
    return () => {
      delete (window as unknown as { __BLOG_SLUG_MAPPINGS__?: Record<Locale, string> }).__BLOG_SLUG_MAPPINGS__;
    };
  }, [slugMappings]);

  return null;
}
